function fetchProductData(target) {

    let handle = $(target).attr('product-id');
    let variant = $(target).attr('variant');
    let url = `/products/${handle}?section_id=garantia-produto`;
    
    if(variant){
        url = `/products/${handle}?variant=${variant}&section_id=garantia-produto`;
    }

    $.ajax({
        url: url,
        type: "GET",
        beforeSend: function(){
            target.addClass('waiting');
        },
        success: function (response) {
            try {
                // Extrai apenas o JSON de dentro da <div>
                let jsonMatch = response.match(/{[\s\S]*}/);
                if (jsonMatch) {
                    let data = JSON.parse(jsonMatch[0]); // Converte para JSON

                    if (!data.error) {
                        console.log(data);
                        target.removeClass('waiting');
                        openModalGarantia(data);
                    } else {
                        console.error("Erro: Produto não encontrado.");
                    }
                } else {
                    console.error("Erro: JSON não encontrado na resposta.");
                }
                
                target.removeClass('waiting');
            } catch (e) {
                console.error("Erro ao processar JSON:", e);
                target.removeClass('waiting');
            }
        },
        error: function () {
            console.error("Erro ao buscar os dados do produto.");
        },
    });
}

function openModalGarantia(data){
    if(data){
        $('.garantia-container').addClass('active');
        $(".garantia-items").html('');
        $('.add-cart-garantia').attr('data-id', data.id);

        data.garantias.forEach( (item, index) => {
            let isFirst = index === 0; // Verifica se é o primeiro item
            
            if (isFirst){
                $('.cart__checkout-button').attr('data-garantia', item.id );
            }

            let garantiaHtml = `
            <div class="item ${isFirst ? "selected" : ""}" data-id="${item.id}">
              <p class="name">${item.title}</p>
              <p class="price">${item.price}</p>
            </div>
          `;

          $(".garantia-items").append(garantiaHtml);
        });   

        $(".garantia-items .item").click(function(e){
            e.preventDefault();
            
            $(".garantia-items .item").removeClass('selected')
            $(this).addClass('selected');
            $('.cart__checkout-button').attr('data-garantia', $(this).attr('data-id'));
        });

        $('.add-cart-garantia').click(function(e){
            e.preventDefault();
            addProdutoGarantia($(this));
        });

    }
}

function addProdutoGarantia(target) {
    let produto = parseInt(target.attr('data-id'), 10);
    let garantia = parseInt(target.attr('data-garantia'), 10);
    let originalText = target.text();
    let items = [];

    // Adiciona o produto principal ao carrinho
    if (produto) {
        items.push({
            id: produto,
            quantity: 1
        });
    }

    // Adiciona a garantia se existir e for um número válido
    if (!isNaN(garantia) && garantia > 0) {
        items.push({
            id: garantia,
            quantity: 1
        });
    }
 
    if (items.length === 0) {
        console.error("Nenhum item válido para adicionar ao carrinho.");
        return;
    }

    // Envia os produtos para o carrinho via AJAX
    $.ajax({
        url: "/cart/add.js",
        type: "POST",
        dataType: "json",
        contentType: "application/json", // Define o tipo de conteúdo
        data: JSON.stringify({ items: items }), // Serializa os dados corretamente
        beforeSend: function(){
            target.text('Adicionando ao Carrinho...');
        },
        success: function (response) {
            console.log("Produtos adicionados com sucesso!", response);
            window.location.href = '/cart'; 
        },
        error: function (error) {
            console.error("Erro ao adicionar produtos:", error);
            target.text(originalText);
        }
    });
}

function initSliderProduto(){

        var swiperOptions = {
          spaceBetween: 10,
          navigation: {
            nextEl: '.proximo5',
            prevEl: '.anterior5',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        };
    
        if (window.innerWidth > 768) {
          var swiperThumbs = new Swiper('.gallery-thumbs', {
            spaceBetween: 20,
            slidesPerView: 6,
            freeMode: true,
            watchSlidesProgress: true,
          });
          swiperOptions.thumbs = { swiper: swiperThumbs };
        }
        var swiperMain = new Swiper('.gallery-main', swiperOptions);
}

function initSliderThumbnails(){

    $('slider-component').each(function () {
        var $sliderWrapper = $(this);
        var $slider = $sliderWrapper.find('ul');
        var $progressBar = $sliderWrapper.find('.slider-progress__bar');
      
        function updateProgress() {
            var scrollLeft = $slider.scrollLeft();
            var scrollWidth = $slider[0].scrollWidth;
            var clientWidth = $slider.outerWidth();
            var maxScroll = scrollWidth - clientWidth;
      
            // Evita divisão por zero
            if (maxScroll <= 0) {
              $progressBar.css('width', '100%');
              return;
            }
      
            var percentage = (scrollLeft / maxScroll) * 100;
            $progressBar.css('width', percentage + '%');
        }
      
        // Atualiza ao rolar
        $slider.on('scroll', function () {
            updateProgress();
        });
      
        // Atualiza inicialmente
        updateProgress();
    });
}

function verificarProdutosAtivos() {
    let qtdAtivos = 0;
    let total = 0;
  
    $('.item-comprar').each(function () {
      const $produto = $(this).find('.assign-produto.active');
      if ($produto.length > 0) {
        qtdAtivos++;
  
        const precoBr = $produto.attr('data-price'); // CORRIGIDO: .attr() ao invés de .data()
        
        if (precoBr) {
          const precoNormalizado = parseFloat(
            precoBr.replace(/\./g, '').replace(',', '.')
          );
  
          if (!isNaN(precoNormalizado)) {
            total += precoNormalizado;
          }
        }
      }
    });
  
    const $btn = $('.btn-comprar-junto');
    $btn.toggleClass('active', qtdAtivos > 0);
    $btn.find('.qtd').text(qtdAtivos);
  
    const totalFormatado = total.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL', 
      minimumFractionDigits: 2
    });

    $btn.find('.price-num').text(totalFormatado);
}  

// Inicializa as Thumbnails
initSliderThumbnails();

jQuery(document).ready(function ($) {
    
    // Evento de clique nas abas do footer no mobile
    var mobile = isMobile();
    if (mobile === true) {
        $('.footer-block .footer-block__heading').on('click', function (e) {
            console.log(e.target);
            e.preventDefault();
            $(this).parent().find('.footer-block__details-content').slideToggle();
        });
    }

    function isMobile() {
        let tela = $(window).width();
        if (tela <= 750) {
            return true;
        } else {
            return false;
        }
    }

    $('.btn-cart-garantia').click(function (e) {
        e.preventDefault();
        fetchProductData($(this));
    }); 

    $('.btn-topo').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 600);
    });

    $('.drawer-filter-mobile .filter-toggle').click(function (e) {
        e.preventDefault();
        console.log(e);
        $(this).toggleClass('active');
        $(this).parent().parent().find('.drawer-filter-content').slideToggle();
    });

    $('.garantia-container .return-drawer, .garantia-container .drawer__close, #garantia-overlay').click(function (e) {
        e.preventDefault();
        $('.garantia-container').removeClass('active');
    });

    $('.product-pay-info .info-toggle').click(function(e) {
        e.preventDefault();
        $(this).parent().find('.info-content').slideToggle();
    });

    $('.assign-produto').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        verificarProdutosAtivos();
    }); 
    
    $('.btn-comprar-junto').click(function (e) {
        e.preventDefault();
        
        let itensParaAdicionar = [];
        
        $('.item-comprar button').each(function(){
            let $item = $(this).closest('.item-comprar');
            let formElement = $item.find('.assign-produto');

            if(formElement.hasClass('active')){
                let productId = $(formElement).data('product');
    
                // Adiciona ao array no formato esperado pela API do Shopify
                itensParaAdicionar.push({
                    id: productId,
                    quantity: 1
                });
            }
        });

        if (itensParaAdicionar.length === 0) {
            console.log('Nenhum produto ativo para adicionar.');
            return;
        }

        // Envia todos os itens em um único request
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: itensParaAdicionar })
        }).then(response => response.json())
            .then(data => {
                console.log('Produtos adicionados:', data); 
                $('.btn-cart-garantia, .product-form__buttons button').click();
            });
    });     

    if(!mobile){

        $('.lower-menu .list-menu--inline li').on('mouseenter', function(){
            $(this).find('details').first().attr('open', true);
            $('.desktop-menu-overlay').addClass('active');
        });
        
        $('.lower-menu .list-menu--inline li').on('mouseleave', function(){
            $(this).find('details').first().attr('open', false);
            
            const algumAberto = $('.lower-menu details').toArray().some(el => el.open);
            const megaMenuAberto = $('.desktop-categories-menu').hasClass('active');

            if (!algumAberto && !megaMenuAberto) {
                $('.desktop-menu-overlay').removeClass('active');
            }
            
        });

        try{
            /* ======== EFEITO SCROLL DA GALERIA - INÍCIO =============*/
            var $productTop = $('.product-top-content');
            var $productInfo = $('product-info');
            let originalOffset = $productTop.offset().top;
            let topHeight = $productTop.outerHeight();
            // Caso esteja usando uma classe no lugar de um tag custom
            // var $productInfo = $('.product-info');
            
            // Offset visual do topo
            var marginTop = 150;

            $(window).on('scroll', function() {
                let infoOffset = $productInfo.offset().top;
                let infoHeight = $productInfo.outerHeight();
                let maxTranslate = (infoOffset + infoHeight) - (originalOffset + topHeight);

                let scrollTop = $(window).scrollTop();
                let move = 0;

                if (scrollTop > originalOffset) {
                move = scrollTop - (originalOffset - marginTop);

                if (move >= maxTranslate) {
                    move = maxTranslate; // TRAVA no limite
                }

                $productTop.css('transform', 'translateY(' + move + 'px)');
                } else {
                $productTop.css('transform', 'translateY(0)');
                }
            });
            /* ======== EFEITO SCROLL DA GALERIA - FIM =============*/ 
        }catch(e){
            //console.log(e);
        }


        /* ======== COMPORTAMENTO - MEGAMENU CATEGORIAS - INICIO =============*/ 
        let firstTarget = $('.lower-menu .desktop-categories-menu .root-categories li:first-child').attr('data-id'); 
        $('.lower-menu .desktop-categories-menu .root-categories li:first-child a').addClass('active');
        $(`.lower-menu .desktop-categories-menu .children-categories ul[data-id="${firstTarget}"]`).addClass('active');

        $('#cat-menu-toggle').on('click', function(e){
            e.preventDefault();
            $('.desktop-categories-menu').toggleClass('active');
            $('.desktop-menu-overlay').toggleClass('active');
        });

        $('.desktop-menu-overlay').on('click', function(e){
            $('.desktop-categories-menu').removeClass('active');
            $(this).removeClass('active');
        });

        $('.lower-menu .desktop-categories-menu .root-categories li').on('mouseenter', function(){
            let target = $(this).attr('data-id');
            $('.lower-menu .desktop-categories-menu .root-categories li').removeClass('active'); 
            $(`.lower-menu .desktop-categories-menu .children-categories ul`).removeClass('active');

            $(this).addClass('active');
            $(`.lower-menu .desktop-categories-menu .children-categories ul[data-id="${target}"]`).addClass('active');
        });
        /* ======== COMPORTAMENTO - MEGAMENU CATEGORIAS - FIM =============*/ 
        
        $('.first-layer-submenu').on('mouseenter', function(e){
            let target = $(this).attr('data-target');
            $('.second-layer-submenu').removeClass('active');
            
            if(target){
                $(`.second-layer-submenu[data-target="${target}"]`).addClass('active');
            }            
        });
        
        $('.second-layer-submenu').on('mouseleave', function(e){
            $(this).removeClass('active');
        });

    }

    // Efeito sticky no botão comprar na PDP
    if(mobile){
        $(window).on('scroll', function () {
        var infoTop = $('.product__info-container').offset().top + $('.product__info-container').outerHeight();
        var scrollTop = $(window).scrollTop();

        if (scrollTop > infoTop) {
            $('.sticky-buy').addClass('active');
        } else {
            $('.sticky-buy').removeClass('active');
        }
        });
    }
    
    $('.desc-mais').on('click',function (e){
        e.preventDefault();
        $(this).parent().find('.content').toggleClass('active');
    });

    // Efeito de clique no botão de afiliado
    $('#afiliado-link').on('click',function (e){
        e.preventDefault();
        var text = $(this).text();
        var link = $(this).attr('data-link');
        $(this).text('Copiado!');
        
        setTimeout(() => {
            $(this).text(text);
        }, 2000 );

        navigator.clipboard.writeText(link)
        .then(function() {    
            console.log("link copiado!");
        })
        .catch(function(err) {
            console.error('Erro ao copiar:', err);
        });
    });


    $('.search-tab-list li').on('click', function (e){
        e.preventDefault();
        
        let target = $(this).attr('data-target');
        $('.search-tab, .search-tab-list li').removeClass('active');
        
        console.log(target);
        
        $(this).addClass('active');
        $(`.search-tab[data-target="${target}"]`).addClass('active'); 
    });

});